var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 158,
    width: 342,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 9.5,
    stroke: "#000",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 49.25,
    stroke: "#0081c8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 54,
    r: 49.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 54,
    r: 49.25,
    stroke: "#ee334e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 104,
    r: 49.25,
    stroke: "#fcb131"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.5,
    cy: 104,
    r: 49.25,
    stroke: "#00a651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4,24.45A49.25,49.25 0 0 1 93.4,83.55",
    stroke: "#0081c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4,24.45A49.25,49.25 0 0 1 210.4,83.55M171,103.25A49.25,49.25 0 0 1 141.45,93.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,103.25A49.25,49.25 0 0 1 258.45,93.4",
    stroke: "#ee334e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4c59e4005ef3edde054e3225ffd21561.svg";
export { ForwardRef as ReactComponent };